import { Permission } from 'src/app/pages/admin/permissions/models/permission.model';

export interface UserLogan {
  id: number;
  email: string;
  name: string;
  screens: string;
  screensList: string[];
  filterMovidaTransfer: Boolean;
  airports: string;
  airportsList: any[];
  permissions?: Permission[];
}
export class UserLoganAirports {
  filterMovidaTransfer?: Boolean;
  airports?: string;
}
